import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 404 | 黑料剧场",
    description:
      "你访问的页面不存在。返回黑料剧场首页或排行榜，继续浏览黑料短剧排行榜、热门短剧与新剧推荐。",
    keywords: "黑料短剧,黑料短剧排行榜,页面不存在",
    path: "/404",
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-page flex-col items-center px-4 py-32 text-center md:px-6 md:py-40">
        <span className="font-heading text-7xl font-black text-primary-500/80 md:text-9xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址可能已变更或被移除：
          <span className="ml-1 font-mono text-foreground-500">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-950 transition-colors hover:bg-primary-400 cursor-pointer"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            回到首页
          </Link>
          <Link
            to="/ranking"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-3 text-sm font-label text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-400 cursor-pointer"
          >
            <i className="ri-trophy-line" aria-hidden="true"></i>
            查看排行榜
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}